export const SUPPORTED_LANGS = [
  { code: "en", label: "EN", name: "English", flag: "🇺🇸" },
  { code: "ru", label: "RU", name: "Русский", flag: "🇷🇺" },
  { code: "es", label: "ES", name: "Español", flag: "🇪🇸" },
];

export const translations = {
  en: {
    nav: {
      portfolio: "Portfolio",
      services: "Services",
      process: "Process",
      about: "Studio",
      contact: "Contact",
      login: "Login",
      logout: "Logout",
      dashboard: "Dashboard",
      new_project: "New Project",
    },
    hero: {
      eyebrow: "Frame-by-Frame Animation Studio",
      title_lines: ["STUDIO OF", "FRAME-BY-FRAME", "ANIMATION"],
      title: "STUDIO OF FRAME-BY-FRAME ANIMATION",
      sub: "Creative union of artists — we create frame-by-frame animation and illustrations. Different styles, one traditional technique.",
      tags: "CYBERPUNK · RETRO · ANIME · COZY AESTHETICS",
      meta: "BASED IN KAZAKHSTAN / WORKING WORLDWIDE",
      studio_online: "STUDIO ONLINE",
      v_year: "V.2026",
      coords_short: "N 51.169° / E 71.449°",
      services: "MUSIC VIDEOS ■ TRAILERS & PROMOS ■ BRAND COMMERCIALS ■ SERIES TITLE SEQUENCES ■ VISUAL DEVELOPMENT",
      cta_portfolio: "WATCH PORTFOLIO",
      cta_contact: "START PROJECT",
    },
    portfolio: {
      label: "Selected Work",
      title: "Projects",
      video: "Video",
      video_2: "Video 2",
      intro: "Intro",
      outro: "Outro",
      cover: "Cover",
      gallery: "Gallery",
      filter_all: "All",
      view: "View Project",
      back: "Back",
      client: "Client",
      year: "Year",
      duration: "Duration",
      tools: "Tools",
      no_video: "No video yet",
    },
    services: {
      label: "What we do",
      title: "Services",
      from: "from",
      revisions: "3 revisions included",
      items: [
        {
          title: "Illustration & Concept Art",
          desc: "Original key visuals, character design, and concept art tailored to your brand or story.",
          price: 800,
        },
        {
          title: "YouTube & Social Visual Packaging",
          desc: "Channel intros, lower thirds, looping idents and motion stickers with a coherent visual identity.",
          price: 1100,
        },
        {
          title: "Mixed Media (2D + Live Action)",
          desc: "Hybrid pieces combining hand-drawn animation, rotoscoping, and live footage.",
          price: 1300,
        },
        {
          title: "Film, Music & Trailers",
          desc: "Music videos, opening titles, trailers and short films with original animation.",
          price: 1500,
        },
        {
          title: "Story Content & Relax Video",
          desc: "Long-form looping lo-fi scenes, story shorts, and meditative animated environments.",
          price: 900,
        },
      ],
    },
    process: {
      label: "How we work",
      title: "Process",
      steps: [
        { title: "Concept & Script", desc: "Brief deep-dive, narrative, references and direction." },
        { title: "Storyboard & Visual Direction", desc: "Frame layout, color script and style frames." },
        { title: "Animation", desc: "Frame-by-frame work in TVPaint / Procreate / After Effects." },
        { title: "Final Compositing", desc: "Color, FX, sound sync and delivery in your formats." },
      ],
    },
    about: {
      label: "Studio",
      title: "Ksenia · Kuryarti",
      role: "Frame-by-frame Animator & Creative Director",
      bio: "Kuryarti is a one-room studio that draws every frame by hand. Six years of work for musicians, indie films, and brands across four countries — built on quiet attention, sharp lines, and emotional storytelling.",
      stats: [
        { value: "6+", label: "Years" },
        { value: "50+", label: "Projects" },
        { value: "4", label: "Countries" },
      ],
    },
    contact: {
      label: "Get in touch",
      title: "Start a project",
      name: "Name",
      email: "Email",
      project_type: "Project type",
      budget: "Budget",
      message: "Tell us about your idea",
      send: "Send brief",
      sent: "Thank you — we will reply within 48h.",
      sent_error: "Something went wrong. Please try again.",
      budgets: ["$10,000+", "$5,000–10,000", "$2,000–5,000", "Under $2,000", "Not defined yet"],
      types: ["Music Video", "Commercial", "Short Film", "Social Packaging", "Other"],
      or: "or reach out directly",
      book_call: "Book a call",
    },
    footer: {
      rights: "All rights reserved",
      privacy: "Privacy",
      terms: "Terms",
    },
    auth: {
      welcome: "Welcome to Kuryarti",
      sub: "Sign in to access your project dashboard and brief.",
      email: "Email",
      password: "Password",
      name: "Full name",
      login: "Sign in",
      register: "Create account",
      continue_google: "Continue with Google",
      no_account: "No account?",
      have_account: "Already have an account?",
      switch_register: "Create one",
      switch_login: "Sign in",
      or: "or",
      loading: "Working…",
      forgot_link: "Forgot password?",
      forgot_send: "Send reset link",
      forgot_sent: "Reset link sent to your email. Check your inbox.",
      forgot_not_found: "This email is not registered.",
    },
    reset: {
      title: "Set a new password",
      new_password: "New password",
      confirm: "Confirm password",
      submit: "Update password",
      done_title: "Password updated",
      done_sub: "You can now sign in with your new password.",
      invalid: "This reset link is invalid or expired.",
      min: "Password must be at least 8 characters",
      match: "Passwords do not match",
      back: "Back to home",
    },
    dashboard: {
      title: "Project Dashboard",
      sub: "Active and recent work in one place.",
      projects: "Projects",
      brief: "Brief",
      files: "Files",
      status_active: "In progress",
      status_review: "In review",
      status_completed: "Completed",
      stage: "Stage",
      deadline: "Deadline",
      progress: "Progress",
      empty: "No projects yet. Submit a brief to get started.",
      brief_intro: "A short brief helps us understand your project. We typically reply within 48h.",
      brief_save: "Submit brief",
      brief_q: [
        "Project working title",
        "Target audience",
        "Mood references / links",
        "Desired duration",
        "Deadline",
        "Budget range",
      ],
      brief_sent: "Brief submitted. We will be in touch.",
      files_soon: "File uploads will be enabled here once your project starts.",
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Last updated: August 2026 · Draft for review",
      sections: [
        {
          h: "Who we are",
          b: "Kuryarti is a frame-by-frame animation studio based in Kazakhstan, operated by Ksenia [surname] as a freelance artist and sole proprietor (individual entrepreneur, ИП) registered in the Republic of Kazakhstan, [БИН / ИИН], [registered address]. This website presents our work, receives project briefs and supports communication with clients.\n\nContact: hello@kuryarti.com",
        },
        {
          h: "What we collect",
          b: "When you register or submit a brief or contact form, we collect the information you provide: name, email address, project details, budget range and any message you write.\n\nWe also store a secure, hashed version of your password, your profile picture and basic technical data needed to operate the site (such as session cookies and IP address).",
        },
        {
          h: "Legal basis",
          b: "We process your data on the basis of: (1) the Republic of Kazakhstan Law No. 94-V of 21 May 2013 \"On Personal Data and their Protection\", which regulates the collection and processing of personal data in Kazakhstan; (2) your consent, which you may withdraw at any time; and (3) — for clients in the European Economic Area — the GDPR (Article 6(1)(b) performance of a contract and 6(1)(f) legitimate interest).",
        },
        {
          h: "How we use your data",
          b: "We use your information to reply to your inquiry, manage your project brief, keep you updated on project status and — with your consent — send occasional studio news.\n\nWe do not sell or rent your personal data to anyone.",
        },
        {
          h: "Where data is stored",
          b: "Your data is stored on our servers in Frankfurt, Germany (DigitalOcean, EU). To operate the site we use a limited number of processors: Resend (transactional email), Google (sign-in via Google account) and Payoneer (payments). Each processor applies its own privacy policy to the data it handles.",
        },
        {
          h: "How long we keep it",
          b: "We keep your account data for as long as your account is active or as required by law. Project briefs, messages and payment records are kept for the duration of the project and up to 3 years afterwards for accounting and legal purposes, after which they are deleted.",
        },
        {
          h: "Cookies & sessions",
          b: "We use strictly necessary cookies to keep you signed in. We do not run advertising trackers on this site.",
        },
        {
          h: "Your rights",
          b: "You may request access to, correction of, or deletion of your personal data at any time by writing to hello@kuryarti.com, and you can delete your account from the settings panel.\n\nIf you are in the European Economic Area, the GDPR also gives you the rights to data portability, restriction of processing and objection, as well as the right to lodge a complaint with your local data protection authority.",
        },
      ],
    },
    terms: {
      title: "Terms of Service",
      updated: "Last updated: August 2026 · Draft for review",
      sections: [
        {
          h: "The agreement",
          b: "By using this website or submitting a project brief, you agree to these terms. This agreement is concluded with Ksenia [surname], the operator of the Kuryarti studio, acting as a freelance artist and sole proprietor (individual entrepreneur, ИП) registered in the Republic of Kazakhstan. Each project is confirmed individually by the studio before work begins.",
        },
        {
          h: "Project briefs",
          b: "Submitting a brief is a request for a quote, not a binding order. The studio will reply within 48 hours with availability, timeline and a quote.",
        },
        {
          h: "Quotes & payments",
          b: "Each project is quoted individually in USD. A deposit (typically 50% of the quote) is required before work starts; the balance is due before final delivery. Payment links are issued through a third-party provider (Payoneer). Prices do not include taxes unless stated otherwise.",
        },
        {
          h: "Revisions & delivery",
          b: "Standard projects include up to 3 rounds of revisions. Final files are delivered digitally in the agreed formats. Additional revisions or changes of scope may be quoted separately and extend the delivery timeline accordingly.",
        },
        {
          h: "Intellectual property",
          b: "Full copyright of commissioned work transfers to the client after full payment. The studio retains the right to show finished work in its portfolio unless agreed otherwise in writing.",
        },
        {
          h: "Cancellation & refunds",
          b: "If you cancel a project after it has started, the deposit is non-refundable and covers work completed up to the cancellation date. If the studio cancels, deposits already paid are refunded in full.",
        },
        {
          h: "Liability",
          b: "The studio is not liable for delays caused by client feedback, third-party services or force majeure. In any case, liability is limited to the amount paid for the affected project.",
        },
        {
          h: "Governing law & disputes",
          b: "These terms are governed by the laws of the Republic of Kazakhstan. The parties will first attempt to resolve any dispute through negotiation; disputes not resolved within 30 days shall be submitted to the competent courts of the Republic of Kazakhstan.",
        },
      ],
    },
  },

  ru: {
    nav: {
      portfolio: "Портфолио",
      services: "Услуги",
      process: "Процесс",
      about: "Студия",
      contact: "Контакты",
      login: "Войти",
      logout: "Выйти",
      dashboard: "Кабинет",
      new_project: "Новый проект",
    },
    hero: {
      eyebrow: "Студия покадровой анимации",
      title_lines: ["СТУДИЯ", "ПОКАДРОВОЙ", "АНИМАЦИИ"],
      title: "СТУДИЯ ПОКАДРОВОЙ АНИМАЦИИ",
      sub: "Творческое объединение художников — создаем покадровую анимацию и иллюстрации. Разные стили, единая традиционная техника.",
      tags: "КИБЕРПАНК · РЕТРО · АНИМЕ · УЮТНАЯ ЭСТЕТИКА",
      meta: "КАЗАХСТАН / РАБОТАЕМ ПО ВСЕМУ МИРУ",
      studio_online: "СТУДИЯ ОНЛАЙН",
      v_year: "V.2026",
      coords_short: "N 51.169° / E 71.449°",
      services: "МУЗЫКАЛЬНЫЕ КЛИПЫ ■ ТРЕЙЛЕРЫ И ПРОМО-РОЛИКИ ■ РЕКЛАМНАЯ АНИМАЦИЯ ■ ЗАСТАВКИ К СЕРИАЛАМ ■ РАЗРАБОТКА ВИЗУАЛЬНОГО СТИЛЯ",
      cta_portfolio: "СМОТРЕТЬ ПОРТФОЛИО",
      cta_contact: "НАЧАТЬ ПРОЕКТ",
    },
    portfolio: {
      label: "Избранные работы",
      title: "Проекты",
      video: "Видео",
      video_2: "Видео 2",
      intro: "Интро",
      outro: "Аутро",
      cover: "Обложка",
      gallery: "Галерея",
      filter_all: "Все",
      view: "Смотреть",
      back: "Назад",
      client: "Клиент",
      year: "Год",
      duration: "Длительность",
      tools: "Инструменты",
      no_video: "Видео пока нет",
    },
    services: {
      label: "Что мы делаем",
      title: "Услуги",
      from: "от",
      revisions: "3 правки включены",
      items: [
        {
          title: "Иллюстрация и концепт-арт",
          desc: "Авторские ключевые визуалы, дизайн персонажей и концепт-арт под ваш бренд или историю.",
          price: 800,
        },
        {
          title: "Визуал для YouTube и соцсетей",
          desc: "Интро, плашки, заставки и стикеры в едином стиле.",
          price: 1100,
        },
        {
          title: "Mixed Media (2D + live action)",
          desc: "Гибридные работы: ручная анимация, ротоскопинг и съёмка.",
          price: 1300,
        },
        {
          title: "Кино, музыка и трейлеры",
          desc: "Клипы, титры, трейлеры и короткометражки с оригинальной анимацией.",
          price: 1500,
        },
        {
          title: "Story-контент и relax видео",
          desc: "Длинные лоу-фай сцены, story-короткометражки и медитативные среды.",
          price: 900,
        },
      ],
    },
    process: {
      label: "Как мы работаем",
      title: "Процесс",
      steps: [
        { title: "Концепт и сценарий", desc: "Погружение в бриф, нарратив, референсы." },
        { title: "Раскадровка и визуальный курс", desc: "Раскадровка, цветовой сценарий, стиль-фреймы." },
        { title: "Анимация", desc: "Покадровая работа в TVPaint / Procreate / After Effects." },
        { title: "Финальный композ", desc: "Цвет, FX, синхронизация и сдача в нужных форматах." },
      ],
    },
    about: {
      label: "Студия",
      title: "Ксения · Kuryarti",
      role: "Покадровый аниматор и креативный директор",
      bio: "Kuryarti — это студия одной комнаты, где каждый кадр нарисован вручную. Шесть лет работы для музыкантов, инди-кино и брендов в четырёх странах — внимание к деталям, точные линии и эмоциональные истории.",
      stats: [
        { value: "6+", label: "лет" },
        { value: "50+", label: "проектов" },
        { value: "4", label: "страны" },
      ],
    },
    contact: {
      label: "Связаться",
      title: "Начать проект",
      name: "Имя",
      email: "Почта",
      project_type: "Тип проекта",
      budget: "Бюджет",
      message: "Расскажите об идее",
      send: "Отправить бриф",
      sent: "Спасибо — ответим в течение 48 часов.",
      sent_error: "Что-то пошло не так. Попробуйте ещё раз.",
      budgets: ["$10 000+", "$5 000–10 000", "$2 000–5 000", "до $2 000", "пока не определён"],
      types: ["Клип", "Реклама", "Короткометражка", "Соцсети", "Другое"],
      or: "или напишите напрямую",
      book_call: "Записаться на звонок",
    },
    footer: { rights: "Все права защищены", privacy: "Политика", terms: "Условия" },
    auth: {
      welcome: "Добро пожаловать в Kuryarti",
      sub: "Войдите, чтобы получить доступ к панели проектов и брифу.",
      email: "Почта",
      password: "Пароль",
      name: "Имя",
      login: "Войти",
      register: "Создать аккаунт",
      continue_google: "Войти через Google",
      no_account: "Нет аккаунта?",
      have_account: "Уже есть аккаунт?",
      switch_register: "Создать",
      switch_login: "Войти",
      or: "или",
      loading: "Подождите…",
      forgot_link: "Забыли пароль?",
      forgot_send: "Отправить ссылку",
      forgot_sent: "Ссылка для сброса отправлена на вашу почту.",
      forgot_not_found: "Этот email не зарегистрирован.",
    },
    reset: {
      title: "Новый пароль",
      new_password: "Новый пароль",
      confirm: "Повторите пароль",
      submit: "Обновить пароль",
      done_title: "Пароль обновлён",
      done_sub: "Теперь вы можете войти с новым паролем.",
      invalid: "Ссылка недействительна или истекла.",
      min: "Пароль должен быть не короче 8 символов",
      match: "Пароли не совпадают",
      back: "На главную",
    },
    dashboard: {
      title: "Панель проектов",
      sub: "Активные и недавние работы в одном месте.",
      projects: "Проекты",
      brief: "Бриф",
      files: "Файлы",
      status_active: "В работе",
      status_review: "На проверке",
      status_completed: "Готово",
      stage: "Этап",
      deadline: "Дедлайн",
      progress: "Прогресс",
      empty: "Проектов пока нет. Отправьте бриф, чтобы начать.",
      brief_intro: "Короткий бриф помогает понять задачу. Обычно отвечаем в течение 48 часов.",
      brief_save: "Отправить бриф",
      brief_q: [
        "Рабочее название проекта",
        "Целевая аудитория",
        "Референсы / ссылки",
        "Желаемая длительность",
        "Дедлайн",
        "Диапазон бюджета",
      ],
      brief_sent: "Бриф отправлен. Свяжемся с вами.",
      files_soon: "Загрузка файлов появится здесь после старта проекта.",
    },
    privacy: {
      title: "Политика конфиденциальности",
      updated: "Обновлено: август 2026 · черновик для проверки",
      sections: [
        {
          h: "Кто мы",
          b: "Kuryarti — студия покадровой анимации из Казахстана; оператор — Ксения [фамилия], независимый художник, зарегистрированная как индивидуальный предприниматель (ИП) в Республике Казахстан, [БИН/ИИН], [адрес регистрации]. Сайт создан студией для показа работ, приёма брифов и общения с клиентами.\n\nКонтакты: hello@kuryarti.com",
        },
        {
          h: "Что мы собираем",
          b: "При регистрации или отправке брифа/формы мы получаем данные, которые вы указали: имя, email, детали проекта, бюджет и сообщение.\n\nМы также храним защищённый хэш пароля, фото профиля и технические данные, необходимые для работы сайта (например, cookies сессии и IP-адрес).",
        },
        {
          h: "Правовое основание",
          b: "Мы обрабатываем данные на основании: (1) Закона Республики Казахстан «О персональных данных и их защите» (№ 94-V от 21.05.2013), регулирующего сбор и обработку персональных данных в Казахстане; (2) вашего согласия, которое можно отозвать в любой момент; (3) — для клиентов из ЕЭЗ — GDPR (ст. 6(1)(b) исполнение договора и 6(1)(f) законный интерес).",
        },
        {
          h: "Как мы используем данные",
          b: "Мы используем ваши данные, чтобы ответить на запрос, вести ваш проект, сообщать о статусе и — с вашего согласия — присылать новости студии.\n\nМы не продаём и не передаём ваши личные данные третьим лицам.",
        },
        {
          h: "Где хранятся данные",
          b: "Данные хранятся на наших серверах во Франкфурте, Германия (DigitalOcean, ЕС). Для работы сайта мы используем ограниченный круг операторов: Resend (транзакционные письма), Google (вход через аккаунт Google) и Payoneer (оплата). К каждому оператору применяется его собственная политика конфиденциальности.",
        },
        {
          h: "Срок хранения",
          b: "Данные аккаунта хранятся, пока аккаунт активен или пока это требуется законом. Брифы, сообщения и записи об оплате хранятся в течение проекта и до 3 лет после него для бухгалтерских и юридических целей, после чего удаляются.",
        },
        {
          h: "Cookies и сессии",
          b: "Мы используем только технически необходимые cookies для входа в аккаунт. Рекламных трекеров на сайте нет.",
        },
        {
          h: "Ваши права",
          b: "Вы можете запросить доступ, исправление или удаление своих данных в любое время, написав на hello@kuryarti.com; удалить аккаунт можно и в настройках профиля.\n\nЕсли вы находитесь в Европейской экономической зоне, GDPR также предоставляет вам права на переносимость данных, ограничение обработки и возражение, а также право подать жалобу в ваш местный орган по защите данных.",
        },
      ],
    },
    terms: {
      title: "Условия использования",
      updated: "Обновлено: август 2026 · черновик для проверки",
      sections: [
        {
          h: "Соглашение",
          b: "Используя сайт или отправляя бриф, вы соглашаетесь с этими условиями. Договор заключается с Ксенией [фамилия] — оператором студии Kuryarti, действующей как индивидуальный предприниматель (ИП), зарегистрированный в Республике Казахстан. Каждый проект подтверждается студией отдельно до начала работы.",
        },
        {
          h: "Брифы",
          b: "Отправка брифа — это запрос расчёта, а не заказ. Студия отвечает в течение 48 часов: сроки, стоимость и план работы.",
        },
        {
          h: "Стоимость и оплата",
          b: "Каждый проект оценивается индивидуально в долларах США. Для старта требуется предоплата (обычно 50% от суммы); остаток — до финальной сдачи. Ссылки на оплату выставляются через платёжный сервис (Payoneer). Цены не включают налоги, если не указано иное.",
        },
        {
          h: "Правки и сдача",
          b: "Стандартный проект включает до 3 раундов правок. Финальные файлы передаются в цифровом виде в согласованных форматах. Дополнительные правки или изменения объёма работ оцениваются отдельно и могут увеличить сроки.",
        },
        {
          h: "Интеллектуальная собственность",
          b: "Авторские права на заказную работу переходят клиенту после полной оплаты. Студия оставляет за собой право показывать готовые работы в портфолио, если не согласовано иное в письменной форме.",
        },
        {
          h: "Отмена и возвраты",
          b: "При отмене проекта после начала работ предоплата не возвращается и покрывает выполненную работу. Если проект отменяет студия, внесённая предоплата возвращается полностью.",
        },
        {
          h: "Ответственность",
          b: "Студия не отвечает за задержки, вызванные комментариями клиента, сторонними сервисами или форс-мажором. Ответственность ограничена суммой оплаты по проекту.",
        },
        {
          h: "Применимое право и споры",
          b: "Эти условия регулируются законодательством Республики Казахстан. Стороны сначала попытаются урегулировать споры путём переговоров; споры, не урегулированные в течение 30 дней, передаются в компетентные суды Республики Казахстан.",
        },
      ],
    },
  },

  es: {
    nav: {
      portfolio: "Portafolio",
      services: "Servicios",
      process: "Proceso",
      about: "Estudio",
      contact: "Contacto",
      login: "Acceder",
      logout: "Salir",
      dashboard: "Panel",
      new_project: "Nuevo Proyecto",
    },
    hero: {
      eyebrow: "Estudio de animación cuadro a cuadro",
      title_lines: ["ESTUDIO DE", "ANIMACIÓN", "CUADRO A CUADRO"],
      title: "ESTUDIO DE ANIMACIÓN CUADRO A CUADRO",
      sub: "Unión creativa de artistas — creamos animación cuadro a cuadro e ilustraciones. Diferentes estilos, una sola técnica tradicional.",
      tags: "CYBERPUNK · RETRO · ANIME · ESTÉTICA ACOGEDORA",
      meta: "BASADOS EN KAZAJISTÁN / TRABAJAMOS EN TODO EL MUNDO",
      studio_online: "ESTUDIO ONLINE",
      v_year: "V.2026",
      coords_short: "N 51.169° / E 71.449°",
      services: "VIDEOS MUSICALES ■ TRAILERS Y PROMOS ■ ANIMACIÓN PUBLICITARIA ■ CABECERAS DE SERIES ■ DESARROLLO VISUAL",
      cta_portfolio: "VER PORTAFOLIO",
      cta_contact: "INICIAR PROYECTO",
    },
    portfolio: {
      label: "Trabajos seleccionados",
      title: "Proyectos",
      video: "Video",
      video_2: "Video 2",
      intro: "Intro",
      outro: "Outro",
      cover: "Portada",
      gallery: "Galería",
      filter_all: "Todos",
      view: "Ver Proyecto",
      back: "Volver",
      client: "Cliente",
      year: "Año",
      duration: "Duración",
      tools: "Herramientas",
      no_video: "Aún no hay video",
    },
    services: {
      label: "Qué hacemos",
      title: "Servicios",
      from: "desde",
      revisions: "3 revisiones incluidas",
      items: [
        {
          title: "Autoría Ilustración & Concept Art",
          desc: "Visuales clave originales, diseño de personajes y concept art para tu marca o historia.",
          price: 800,
        },
        {
          title: "Visual Packaging YouTube & Redes",
          desc: "Intros, plecas, idents en loop y stickers en movimiento con identidad coherente.",
          price: 1100,
        },
        {
          title: "Mixed Media (2D + Live Action)",
          desc: "Piezas híbridas combinando animación a mano, rotoscopia y metraje real.",
          price: 1300,
        },
        {
          title: "Cine, Música & Trailers",
          desc: "Videoclips, títulos, trailers y cortos con animación original.",
          price: 1500,
        },
        {
          title: "Story-content & Relax Video",
          desc: "Escenas lo-fi en loop, micro-cortos y entornos meditativos animados.",
          price: 900,
        },
      ],
    },
    process: {
      label: "Cómo trabajamos",
      title: "Proceso",
      steps: [
        { title: "Concepto y Guión", desc: "Inmersión en el brief, narrativa, referencias y dirección." },
        { title: "Storyboard y Dirección Visual", desc: "Layout, color script y style frames." },
        { title: "Animación", desc: "Cuadro a cuadro en TVPaint / Procreate / After Effects." },
        { title: "Composición Final", desc: "Color, FX, sincronía y entrega en tus formatos." },
      ],
    },
    about: {
      label: "Estudio",
      title: "Ksenia · Kuryarti",
      role: "Animadora cuadro a cuadro y Directora Creativa",
      bio: "Kuryarti es un estudio de una habitación donde cada cuadro se dibuja a mano. Seis años de trabajo para músicos, cine indie y marcas en cuatro países — atención silenciosa, líneas precisas y narrativa emocional.",
      stats: [
        { value: "6+", label: "Años" },
        { value: "50+", label: "Proyectos" },
        { value: "4", label: "Países" },
      ],
    },
    contact: {
      label: "Contacto",
      title: "Iniciar un proyecto",
      name: "Nombre",
      email: "Email",
      project_type: "Tipo de proyecto",
      budget: "Presupuesto",
      message: "Cuéntanos tu idea",
      send: "Enviar brief",
      sent: "Gracias — responderemos en 48h.",
      sent_error: "Algo salió mal. Inténtalo de nuevo.",
      budgets: ["$10.000+", "$5.000–10.000", "$2.000–5.000", "Hasta $2.000", "Aún sin definir"],
      types: ["Videoclip", "Comercial", "Cortometraje", "Redes Sociales", "Otro"],
      or: "o contáctanos directamente",
      book_call: "Reservar llamada",
    },
    footer: { rights: "Todos los derechos reservados", privacy: "Privacidad", terms: "Términos" },
    auth: {
      welcome: "Bienvenido a Kuryarti",
      sub: "Inicia sesión para acceder a tu panel de proyectos y brief.",
      email: "Email",
      password: "Contraseña",
      name: "Nombre completo",
      login: "Iniciar sesión",
      register: "Crear cuenta",
      continue_google: "Continuar con Google",
      no_account: "¿Sin cuenta?",
      have_account: "¿Ya tienes cuenta?",
      switch_register: "Crear una",
      switch_login: "Iniciar sesión",
      or: "o",
      loading: "Cargando…",
      forgot_link: "¿Olvidaste tu contraseña?",
      forgot_send: "Enviar enlace",
      forgot_sent: "Enlace de restablecimiento enviado a tu correo. Revisa tu bandeja.",
      forgot_not_found: "Este correo no está registrado.",
    },
    reset: {
      title: "Establece una nueva contraseña",
      new_password: "Nueva contraseña",
      confirm: "Confirmar contraseña",
      submit: "Actualizar contraseña",
      done_title: "Contraseña actualizada",
      done_sub: "Ya puedes iniciar sesión con tu nueva contraseña.",
      invalid: "Este enlace no es válido o expiró.",
      min: "La contraseña debe tener al menos 8 caracteres",
      match: "Las contraseñas no coinciden",
      back: "Volver al inicio",
    },
    dashboard: {
      title: "Panel de Proyectos",
      sub: "Trabajos activos y recientes en un solo lugar.",
      projects: "Proyectos",
      brief: "Brief",
      files: "Archivos",
      status_active: "En curso",
      status_review: "En revisión",
      status_completed: "Completado",
      stage: "Etapa",
      deadline: "Entrega",
      progress: "Progreso",
      empty: "Aún no hay proyectos. Envía un brief para empezar.",
      brief_intro: "Un brief corto nos ayuda a entender tu proyecto. Solemos responder en 48h.",
      brief_save: "Enviar brief",
      brief_q: [
        "Título de trabajo del proyecto",
        "Audiencia objetivo",
        "Referencias / enlaces",
        "Duración deseada",
        "Fecha límite",
        "Rango de presupuesto",
      ],
      brief_sent: "Brief enviado. Te contactaremos.",
      files_soon: "La carga de archivos se habilitará aquí al iniciar tu proyecto.",
    },
    privacy: {
      title: "Política de Privacidad",
      updated: "Última actualización: agosto 2026 · borrador para revisión",
      sections: [
        {
          h: "Quiénes somos",
          b: "Kuryarti es un estudio de animación cuadro a cuadro con base en Kazajistán, operado por Ksenia [apellido] como artista independiente y empresaria individual (ИП) registrada en la República de Kazajistán, [БИН/ИИН], [dirección registrada]. Este sitio presenta nuestro trabajo, recibe briefs y da soporte a la comunicación con clientes.\n\nContacto: hello@kuryarti.com",
        },
        {
          h: "Qué recopilamos",
          b: "Al registrarte o enviar un brief o el formulario de contacto, recopilamos la información que proporcionas: nombre, correo electrónico, detalles del proyecto, rango de presupuesto y el mensaje.\n\nTambién almacenamos una versión segura (hash) de tu contraseña, tu foto de perfil y datos técnicos básicos necesarios para operar el sitio (como cookies de sesión e IP).",
        },
        {
          h: "Base legal",
          b: "Procesamos tus datos con arreglo a: (1) la Ley de la República de Kazajistán N.º 94-V de 21 de mayo de 2013 \"Sobre datos personales y su protección\", que regula la recogida y el tratamiento de datos personales en Kazajistán; (2) tu consentimiento, que puedes retirar en cualquier momento; y (3) — para clientes del Espacio Económico Europeo — el GDPR (art. 6.1.b cumplimiento de contrato y 6.1.f interés legítimo).",
        },
        {
          h: "Cómo usamos tus datos",
          b: "Usamos tu información para responder tu consulta, gestionar tu brief, mantenerte al día sobre el estado del proyecto y — con tu consentimiento — enviar noticias ocasionales del estudio.\n\nNo vendemos ni alquilamos tus datos personales a nadie.",
        },
        {
          h: "Dónde se almacenan los datos",
          b: "Tus datos se guardan en nuestros servidores en Fráncfort, Alemania (DigitalOcean, UE). Para operar el sitio usamos un número limitado de procesadores: Resend (correos transaccionales), Google (inicio de sesión con cuenta de Google) y Payoneer (pagos). Cada procesador aplica su propia política de privacidad a los datos que maneja.",
        },
        {
          h: "Cuánto tiempo los conservamos",
          b: "Conservamos los datos de tu cuenta mientras esté activa o mientras lo exija la ley. Los briefs, mensajes y registros de pago se guardan durante el proyecto y hasta 3 años después para fines contables y legales, y luego se eliminan.",
        },
        {
          h: "Cookies y sesiones",
          b: "Usamos cookies estrictamente necesarias para mantener tu sesión iniciada. No utilizamos rastreadores publicitarios en este sitio.",
        },
        {
          h: "Tus derechos",
          b: "Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento escribiendo a hello@kuryarti.com, y puedes eliminar tu cuenta desde el panel de ajustes.\n\nSi estás en el Espacio Económico Europeo, el GDPR también te otorga los derechos de portabilidad, limitación del tratamiento y oposición, así como el derecho a presentar una reclamación ante tu autoridad local de protección de datos.",
        },
      ],
    },
    terms: {
      title: "Términos del Servicio",
      updated: "Última actualización: agosto 2026 · borrador para revisión",
      sections: [
        {
          h: "El acuerdo",
          b: "Al usar este sitio o enviar un brief, aceptas estos términos. Este acuerdo se celebra con Ksenia [apellido], operadora del estudio Kuryarti, que actúa como artista independiente y empresaria individual (ИП) registrada en la República de Kazajistán. Cada proyecto se confirma individualmente con el estudio antes de comenzar.",
        },
        {
          h: "Briefs",
          b: "Enviar un brief es una solicitud de cotización, no un pedido vinculante. El estudio responderá en 48 horas con disponibilidad, plazos y presupuesto.",
        },
        {
          h: "Cotizaciones y pagos",
          b: "Cada proyecto se cotiza individualmente en USD. Se requiere un depósito (normalmente el 50% del presupuesto) antes de comenzar; el saldo se paga antes de la entrega final. Los links de pago se emiten a través de un proveedor externo (Payoneer). Los precios no incluyen impuestos salvo que se indique lo contrario.",
        },
        {
          h: "Revisiones y entrega",
          b: "Los proyectos estándar incluyen hasta 3 rondas de revisiones. Los archivos finales se entregan digitalmente en los formatos acordados. Revisiones adicionales o cambios de alcance se cotizan por separado y pueden ampliar el plazo de entrega.",
        },
        {
          h: "Propiedad intelectual",
          b: "Los derechos de autor completos del trabajo por encargo se transfieren al cliente tras el pago total. El estudio se reserva el derecho de mostrar el trabajo terminado en su portafolio salvo acuerdo escrito en contrario.",
        },
        {
          h: "Cancelación y reembolsos",
          b: "Si cancelas un proyecto una vez iniciado, el depósito no es reembolsable y cubre el trabajo realizado hasta la fecha de cancelación. Si el estudio cancela, los depósitos ya pagados se reembolsan íntegramente.",
        },
        {
          h: "Responsabilidad",
          b: "El estudio no es responsable de retrasos causados por comentarios del cliente, servicios de terceros o fuerza mayor. En cualquier caso, la responsabilidad se limita al monto pagado por el proyecto afectado.",
        },
        {
          h: "Ley aplicable y disputas",
          b: "Estos términos se rigen por las leyes de la República de Kazajistán. Las partes intentarán primero resolver cualquier disputa mediante negociación; las disputas no resueltas en 30 días se someterán a los tribunales competentes de la República de Kazajistán.",
        },
      ],
    },
  },
};
